<template>
  <v-row
    no-gutters
    class="h-100"
    justify="space-between"
  >
    <v-col cols="12" offset="0" md="4" offset-md="4" class="d-flex flex-column justify-center align-center">
      <v-card
        class="w-100 rounded-lg"
      >
        <v-card-title>{{ $t('spedilink.unsubscribeNotifications.title') }}</v-card-title>
        <v-card-text>
          <div v-if="loading" class="d-flex justify-center py-6">
            <v-progress-circular
              indeterminate
              color="primary"
            />
          </div>
          <v-alert
            v-else-if="success"
            type="success"
            text
            prominent
          >
            {{ $t('spedilink.unsubscribeNotifications.success') }}
          </v-alert>
          <v-alert
            v-else
            type="error"
            text
            prominent
          >
            {{ $t('spedilink.unsubscribeNotifications.error') }}
          </v-alert>
        </v-card-text>
        <v-card-actions v-if="!loading" class="px-4 mb-4">
          <v-btn color="primary" block @click="$router.push({ name: 'Login' })">
            {{ $t('spedilink.unsubscribeNotifications.goToLogin') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import services from '@/services'

export default {
  name: 'SpedilinkUnsubscribeNotifications',
  data () {
    return {
      loading: true,
      success: false
    }
  },
  async created () {
    const id = this.$route.query.id
    if (!id) {
      this.loading = false
      return
    }

    try {
      await services.put('User/UnsubscribeSpedilinkNotifications', { id })
      this.success = true
    } catch (e) {}
    this.loading = false
  }
}
</script>
